import { render, staticRenderFns } from "./rForm.vue?vue&type=template&id=54378fbe"
import script from "./rForm.vue?vue&type=script&lang=js"
export * from "./rForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports